import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { BusinessProcessService } from '../../../../services/business-process.service';
import { Utils } from '../../../../services/utils';
import { DesignElementType } from '../../../../Models/enum/designElementType';
import { ElementLock } from '../../../../Models/elementLock';
import { CustomValidator } from '../../../../services/custom-validator';
import { GenericModalService } from '../../../../services/generic-modal.service';
import { FieldType } from '../../../../Models/enum/fieldType';
import { EnumTranslator } from '../../../../Models/enum/enumTranslator';
import { WfTableComponent } from '../../../../common/table-sort/wf-table.component';
import { FieldDetailComponent } from '../field-detail/field-detail.component';
import { GenericInputModalComponent } from '../../../../generic-modal/generic-input-modal/generic-input-modal.component';
import { LibraryItemDetailsComponent } from './library-item-details/library-item-details.component';
import { HumanInteractionTokenResult } from '../../../../Models/humanInteractionTokenResult';
import { FieldEditType } from '../../../../Models/enum/fieldEditType';

@Component({
  selector: 'app-business-process-detail',
  templateUrl: './business-process-detail.component.html',
  styleUrls: ['./business-process-detail.component.css', '../../../../styles/business-process-configuration.css']
})
export class BusinessProcessDetailComponent implements OnInit {

  @ViewChild('businessProcessTabs', { static: false }) businessProcessTabs: TabsetComponent;
  @ViewChild('libraryTabs', { static: false }) libraryTabs: TabsetComponent;
  businessProcessForm: FormGroup;
  errorMessage = '';
  errorMessageFlow = '';
  errorMessageLayout = '';
  errorMessageView = '';
  errorMessageValidation = '';
  successMessage = '';
  pleaseWait = false;
  inscription: Subscription;
  utilsFunction = Utils;
  filterFlowText: string;
  filterLayoutText: string;
  filterViewsText: string;
  elementLock: ElementLock = null;
  lockingUserLogon: string;
  isLockedToOtherUser = false;
  isLockedToMe = false;
  isNew: boolean;
  destComponent: any = GenericInputModalComponent;
  libraryDetailsComponent: any = LibraryItemDetailsComponent;
  bpId: number;
  bpInfo: any[];
  flowList = [];
  layoutList = [];
  viewList = [];
  businessProcessErrorList = [];
  unrelatedLibraryItems = [];
  tabIdToSelect: number;
  libraryTabIdToSelect: number;
  graph;
  errorMessageGraph: string;
  get formData() { return this.businessProcessForm.controls; }
  @ViewChild('dataTableStates', { static: false }) dataTableStates: WfTableComponent;
  @ViewChild('dataTableFlows', { static: false }) dataTableFlows: WfTableComponent;
  @ViewChild('dataTableLayouts', { static: false }) dataTableLayouts: WfTableComponent;
  @ViewChild('dataTableFields', { static: false }) dataTableFields: WfTableComponent;
  @ViewChild('dataTableViews', {static: false}) dataTableViews: WfTableComponent;
  @ViewChild('dataTableErrors', {static: false}) dataTableErrors: WfTableComponent;

  constructor(
    private formBuilder: FormBuilder,
    private bpService: BusinessProcessService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: GenericModalService
  ) { }

  ngOnInit() {
    this.isNew = this.router.url === '/newBusinessProcess';
    this.createForm();
    if (this.isNew) {
      this.isLockedToMe = true;
      this.bpInfo = [];
    } else {
      this.inscription = this.route.params.subscribe(params => {
        this.bpId = params['id'];
        this.tabIdToSelect = params['tabId'];
        if (!isNaN(parseFloat(this.bpId.toString()))) {
          this.pleaseWait = true;
          this.getBusinessProcessForManagementById();
        } else {
          this.errorMessage = 'O parâmetro informado não é válido.';
        }
      });
    }
  }

  selectTab() {
    if (this.businessProcessTabs) {
      this.businessProcessTabs.tabs[this.tabIdToSelect > 0 ? this.tabIdToSelect : 0].active = true;
    }
  }

  selectLibraryTab() {
    if (this.libraryTabs) {
      this.libraryTabs.tabs[this.libraryTabIdToSelect > 0 ? this.libraryTabIdToSelect : 0].active = true;
    }
  }

  createForm() {
    this.businessProcessForm = this.formBuilder.group({
      businessProcessId: [ 0 ],
      name: [ '', [ Validators.required, Validators.maxLength(100) ]],
      description: [ '', Validators.maxLength(300)],
      statesExecutionTimeout: [ null, [Validators.max(2147482), Validators.min(1), CustomValidator.numericButNotRequired]],
      continuousExecutionMaxCount: null,
      doContinuousExecution: false,
      initiateQuickInstance: false,
      modifiedBy: localStorage.getItem('userLogon'),
      creationDate: new Date()
    });
  }

  getBusinessProcessForManagementById() {
    this.errorMessage = '';
    this.bpService.getBusinessProcessForManagementById(this.bpId).subscribe(result => {
      if (result) {
        this.bpInfo = result;
        this.getCurrentElementLock();
        this.loadBPData();
        this.loadFields();
        this.loadFlowLibrary();
        this.loadLayoutLibrary();
        this.loadViewLibrary();
        this.loadBusinessProcessValidationErrors();
        this.loadGraph();
        if (this.tabIdToSelect === 2 ) { this.onOpenLibrary(1, 4); }
        this.pleaseWait = false;
      } else {
        this.pleaseWait = false;
        this.errorMessage = 'Processo de negócio não encontrado.';
      }
    }, error1 => {
      this.pleaseWait = false;
      this.errorMessage = error1;
    });
  }

  loadGraph() {
    this.errorMessageGraph = '';
    this.bpService.getGraph(this.bpId)
      .subscribe(result => {
        if (result) {
          this.graph = result.graph;
        } else {
          this.pleaseWait = false;
          this.errorMessageGraph = 'Erro ao gerar o gráfico.';
        }
      }, error => {
        this.pleaseWait = false;
        this.errorMessageGraph = error;
      });
  }

  loadFlowLibrary() {
    this.errorMessageFlow = '';
    this.bpService.getLibraryItems(this.bpId, 1, 4)
      .subscribe(result => {
        if (result) {
          this.flowList = result['libraryItems'];
        } else {
          this.pleaseWait = false;
          this.errorMessageFlow = 'Biblioteca não encontrada.';
        }
        this.selectTab();
        this.selectLibraryTab();
      }, error1 => {
        this.pleaseWait = false;
        this.errorMessageFlow = error1;
      });
  }

  loadLayoutLibrary() {
    this.errorMessageLayout = '';
    this.bpService.getLibraryItems(this.bpId, 2, 5)
      .subscribe(result => {
        if (result) {
          this.layoutList = result['libraryItems'];
        } else {
          this.pleaseWait = false;
          this.errorMessageLayout = 'Biblioteca não encontrada.';
        }
        this.selectTab();
        this.selectLibraryTab();
      }, error1 => {
        this.pleaseWait = false;
        this.errorMessageLayout = error1;
      });
  }

  loadViewLibrary() {
    this.errorMessageView = '';
    this.bpService.getLibraryItems(this.bpId, 3, 6)
      .subscribe(result => {
        if (result) {
          this.viewList = result['libraryItems'];
        } else {
          this.pleaseWait = false;
          this.errorMessageView = 'Biblioteca não encontrada.';
        }
        this.selectTab();
        this.selectLibraryTab();
      }, error1 => {
        this.pleaseWait = false;
        this.errorMessageView = error1;
      });
  }

  loadFields() {
    if (this.bpInfo['fields']) {
      this.bpInfo['fields'].forEach(field => {
        field.typeDescription = this.getFieldTypeEnumTranslated(field.type);
        if (field.type === FieldType.text) {
          field.typeDescription += ` (${field.length})`;
        }
      });
    }
  }

  getCurrentElementLock() {
    this.errorMessage = '';
    this.bpService.getCurrentElementLock(DesignElementType.BusinessProcess, Number(this.bpId))
      .subscribe( element => {
        this.elementLock = element;
        if (element) {
          this.lockingUserLogon = element.user.logon;
          this.isLockedToOtherUser = this.lockingUserLogon && this.lockingUserLogon !== localStorage.getItem('userLogon');
          this.isLockedToMe = this.bpId === 0 ? true : !this.isLockedToOtherUser;
          this.isLockedToOtherUser ? this.businessProcessForm.disable() : this.businessProcessForm.enable();
        } else {
          this.businessProcessForm.disable();
          this.isLockedToOtherUser = false;
          this.isLockedToMe = false;
        }
      }, error1 => this.errorMessage = error1);
  }

  loadBPData() {
    this.businessProcessForm.patchValue({
      businessProcessId: Number(this.bpId),
      name: this.bpInfo['name'],
      description: this.bpInfo['description'],
      statesExecutionTimeout: this.bpInfo['statesExecutionTimeout'] / 1000 === 0 ? null : this.bpInfo['statesExecutionTimeout'] / 1000,
      continuousExecutionMaxCount: this.bpInfo['continuousExecutionMaxCount'] === 0 ? null : this.bpInfo['continuousExecutionMaxCount'],
      doContinuousExecution: this.bpInfo['doContinuousExecution'],
      initiateQuickInstance: this.bpInfo['initiateQuickInstance'],
      creationDate: this.bpInfo['creationDate']
    });
    if (!this.isLockedToMe) { this.businessProcessForm.disable(); }
    this.setContinuousExecutionMaxCountValidation(this.bpInfo['doContinuousExecution']);
  }

  onEdit() {
    this.errorMessage = '';
    if (!this.isLockedToOtherUser) {
      this.businessProcessForm.enable();
      this.bpService.beginEditingElement(DesignElementType.BusinessProcess, Number(this.bpId), this.bpInfo['name'])
        .subscribe( () => { this.getCurrentElementLock(); }, error1 => { this.errorMessage = error1; });
    }
  }

  onUnlock() {
    this.errorMessage = '';
    this.bpService.endEditingElement(DesignElementType.BusinessProcess, Number(this.bpId), this.bpInfo['name'])
      .subscribe( () => {
        this.successMessage = 'Processo de negócio desbloqueado';
        setTimeout(() => {  this.successMessage = ''; this.getCurrentElementLock(); }, 1700);
      }, error1 => this.errorMessage = error1);
  }

  onSave() {
    this.errorMessage = '';
    this.pleaseWait = true;
    const newBpInfo = this.businessProcessForm.getRawValue();
    if (!newBpInfo.doContinuousExecution || !newBpInfo.continuousExecutionMaxCount) {
      newBpInfo.continuousExecutionMaxCount = 0;
    }
    if (newBpInfo.statesExecutionTimeout === '') {
      newBpInfo.statesExecutionTimeout = null;
    }
    if (this.isNew) {
      this.createBusinessProcess(newBpInfo);
    } else {
      this.updateBusinessProcess(newBpInfo);
    }
  }

  onBack() {
    if (this.isLockedToMe) {
      this.onUnlock();
    }
    this.router.navigate(['/businessProcessList']);
  }

  updateBusinessProcess(newBpInfo: any) {
    this.bpService.updateBusinessProcess(newBpInfo).subscribe(
      () => {
        this.successMessage = 'Processo de negócio atualizado com sucesso';
        this.pleaseWait = false;
        setTimeout(() => {  this.successMessage = ''; this.onUnlock(); }, 1700);
      }, error1 => {
        this.errorMessage = error1;
        this.pleaseWait = false;
      }
    );
  }

  createBusinessProcess(newBpInfo: any) {
    this.bpService.createBusinessProcess(newBpInfo).subscribe(
      newBpId => {
        this.successMessage = 'Processo de negócio criado com sucesso';
        this.pleaseWait = false;
        setTimeout(() => {  this.successMessage = ''; this.router.navigate(['/businessProcess', newBpId]); }, 1700);
      }, error1 => {
        this.errorMessage = error1;
        this.pleaseWait = false;
      }
    );
  }

  setContinuousExecutionMaxCountValidation(element) {
    if (element === true || element.checked) {
      this.businessProcessForm.get('continuousExecutionMaxCount').setValidators([
        Validators.max(999),
        Validators.min(1),
        CustomValidator.numeric
      ]);
    } else {
      this.businessProcessForm.get('continuousExecutionMaxCount').clearValidators();
    }
    this.businessProcessForm.get('continuousExecutionMaxCount').updateValueAndValidity();
  }

  // Library management
  onDeleteState(stateId: number) {
    this.errorMessage = '';
    let alert: any;
    alert = this.modalService.showConfirmModal('Confirmação de Exclusão', 'Confirma a exclusão do estado?');
    alert.then((result) => {
      if (result.value) {
        this.bpService.deleteBusinessProcessState(this.bpId, stateId).pipe(take(1))
          .subscribe( () => {
            this.getBusinessProcessForManagementById();
          }, error1 => {
            this.errorMessage = error1;
            setTimeout( () => { document.getElementById('btnBack').focus(); }, 1000);
          });
      }
    });
  }

  onDeleteField(fieldId: number) {
    this.errorMessage = '';
    let alert: any;
    alert = this.modalService.showConfirmModal('Confirmação de Exclusão', 'Confirma a exclusão do campo?');
    alert.then((result) => {
      if (result.value) {
        this.bpService.deleteBusinessProcessField(this.bpId, fieldId).pipe(take(1))
          .subscribe( () => {
            this.tabIdToSelect = 1;
            this.getBusinessProcessForManagementById();
          }, error1 => {
            this.errorMessage = error1;
            setTimeout( () => { document.getElementById('btnBack').focus(); }, 1000);
          });
      }
    });
  }

  onDeleteLibraryItem(item) {
    this.errorMessageLayout = '';
    this.errorMessageFlow = '';
    this.errorMessageView = '';
    let alert: any;
    const itemName = this.getItemTypeName(item.itemType);
    const designElementType = this.getDesignElementType(item.itemType);
    let contraction = 'do';
    if (item.itemType === 3) {
      contraction = 'da';
    }
    alert = this.modalService.showConfirmModal('Confirmação de Exclusão', `Confirma a exclusão ${contraction} ${itemName}?`);
    alert.then((result) => {
      if (result.value) {
        this.bpService.deleteLibraryItem(this.bpId, item.libraryItemId, designElementType).pipe(take(1))
          .subscribe( () => {
            this.tabIdToSelect = 2;
            switch (item.itemType) {
              case 1:
                this.libraryTabIdToSelect = 0;
                this.loadFlowLibrary();
                break;
              case 2:
                this.libraryTabIdToSelect = 1;
                this.loadLayoutLibrary();
                break;
              case 3:
                this.libraryTabIdToSelect = 2;
                this.loadViewLibrary();
                break;
            }
          }, error1 => {
            this.setErrorMessage(item.ItemType, error1);
          });
      }
    });
  }

  onViewField(fieldId: number) {
    const inputDataModal = {
      fieldId: fieldId,
      editType: FieldEditType.single,
      businessProcessId: this.bpId,
    };

    if (fieldId === 0) {
      this.bpService.checkRights(128)
        .subscribe( rights => {
          if (rights.length > 0) {
            this.openField('Cadastrar', inputDataModal);
          } else {
            this.modalService.showErrorMessage('Usuário não tem direito de efetuar esta ação.', true);
          }
        }, error1 => this.modalService.showErrorMessage(error1, true));
    } else {
      this.openField('Editar', inputDataModal);
    }
  }

  openField(viewType, inputDataModal) {
    const destComponent: any = FieldDetailComponent;
    const result$ = this.modalService.showObjModal(destComponent, `${viewType} Campo`, inputDataModal, 'modal-xl');
    if (result$) {
      result$.asObservable()
        .subscribe((result) => {
          this.tabIdToSelect = 1;
          this.getBusinessProcessForManagementById();
        });
    }
  }

  filterFlow() {
    const emptyFilter = (this.flowList && this.flowList.length === 0) ||
      this.filterFlowText === undefined || this.filterFlowText.trim() === '';
    if (emptyFilter) {
      return this.flowList;
    } else {
      return this.flowList.filter((v) => {
        return (v.name.toLowerCase().includes(this.filterFlowText.toLowerCase()));
      });
    }
  }

  filterLayout() {
    const emptyFilter = (this.layoutList && this.layoutList.length === 0) ||
      this.filterLayoutText === undefined || this.filterLayoutText.trim() === '';
    if (emptyFilter) {
      return this.layoutList;
    } else {
      return this.layoutList.filter((v) => {
        return (v.name.toLowerCase().includes(this.filterLayoutText.toLowerCase()));
      });
    }
  }

  filterView() {
    const emptyFilter = (this.viewList && this.viewList.length === 0) ||
      this.filterViewsText === undefined || this.filterViewsText.trim() === '';
    if (emptyFilter) {
      return this.viewList;
    } else {
      return this.viewList.filter((v) => {
        return (v.name.toLowerCase().includes(this.filterViewsText.toLowerCase()));
      });
    }
  }

  updateLibraryItem(item: any) {
    this.errorMessageFlow = '';
    this.errorMessageLayout = '';
    this.errorMessageView = '';

    let contraction = 'do';
    const title = this.getItemTypeName(item.itemType);
    const designElementType = this.getDesignElementType(item.itemType);
    let list: any[];
    switch (item.itemType) {
      case 1:
        list = this.flowList;
        break;
      case 2:
        list = this.layoutList;
        break;
      case 3:
        list = this.viewList;
        contraction = 'da';
        break;
    }
    const result$ = this.modalService.showInputModal(
      this.destComponent,
      `Renomear ${title}`,
      `Insira o novo nome ${contraction} ${title}`,
      'OK', 'Cancelar',
      item.name,
      '^[a-zA-Z][a-zA-Z0-9_]+',
      'Um nome válido deve ter entre 1 e 100 caracteres, deve ser iniciado por letra e deve ser composto somente por letras, números e underscore.',
      100, 1, true
    );
    result$.asObservable()
      .subscribe(
        input => {
          if (input !== null) {
            const allNames = list.map(li => li.name);
            allNames.splice(allNames.indexOf(item.name), 1);
            const newName = input.replace(/\s/g, '');
            if (allNames.includes(newName)) {
              const errorMsg = `Erro: Já existe um ${title} com o nome ${newName}`;
              this.setErrorMessage(item.itemType, errorMsg);
              return;
            }
            const modifiedItem = {
              libraryItemId: item.libraryItemId,
              name: newName
            };
            this.bpService.updateLibraryItem(this.bpId, designElementType, modifiedItem).subscribe(
              () => { item.name = newName; },
              error1 => {
                this.setErrorMessage(item.itemType, error1);
              }
            );
          }
        }
      );
  }

  setErrorMessage(itemType, message) {
    switch (itemType) {
      case 1:
        this.errorMessageFlow = message;
        break;
      case 2:
        this.errorMessageLayout = message;
        break;
      case 3:
        this.errorMessageView = message;
        break;
    }
  }

  openFlowDesignerSetup() {
    window.open('./DesignerSetup/Crivo.Workflow.EditorDeFluxos.msi', '_self');
  }

  openLayoutDesignerSetup() {
    window.open('./DesignerSetup/Crivo.Workflow.EditorDeLayout.msi', '_self');
  }

  openFlowEditor(libraryItem) {
    this.errorMessageFlow = '';
    if ([1, 2, 3].includes(libraryItem.flowType)) {
      let flowExecutionType: number;
      switch (libraryItem.flowType) {
        case 1: flowExecutionType = 3;
        break;
        case 2: flowExecutionType = 1;
        break;
        case 3: flowExecutionType = 2;
        break;
      }
      this.bpService.generateFlowDesignerURL(this.bpId, libraryItem.libraryItemId, flowExecutionType)
        .subscribe((resp: any) => {
          if (resp) {
            window.open(resp.url, '_parent');
          }
        }, error1 => {
          this.errorMessageFlow = error1;
        });
    } else {
      this.errorMessageFlow = 'Erro ao abrir o editor de fluxos. Fluxo não identificado';
    }
  }

  openStateLayoutEditor(layoutId: number) {
    this.bpService.getTokenForLayoutEditor()
      .subscribe((resp: HumanInteractionTokenResult) => {
        if (resp) {
          const options = `{ "BusinessProcessId": ${this.bpId}, "LibraryItemId": ${layoutId} }`;
          window.open(resp.humanInteractionBaseUrl + '/LayoutEditorV2/Default.aspx?Token=' +
            resp.humanInteractionToken + '&LoginHandle=' + resp.loginHandle + '&data=' + options, '_blank');
        }
      });
  }

  openViewLayoutEditor(libraryItem) {
    this.errorMessage = '';
    this.bpService.generateLayoutDesignerURL(this.bpId, libraryItem)
      .subscribe((resp: any) => {
        if (resp) {
          window.open(resp.url, '_parent');
        }
      }, error1 => {
        this.errorMessage = error1;
      });
  }

  onAddFlow(flowType: string) {
    this.errorMessageFlow = '';
    let flowTypeDescription = '';
    switch (flowType) {
      case 'stateFlow': flowTypeDescription = 'Estado';
            break;
      case 'pageFlow': flowTypeDescription = 'Tela';
        break;
      case 'dataFlow': flowTypeDescription = 'Dados';
        break;
      default: this.errorMessageFlow = 'Erro ao criar o fluxo. O tipo de fluxo não foi identificado.';
      return;
    }
    const result$ = this.modalService.showInputModal(
      this.destComponent,
      `Novo fluxo de ${flowTypeDescription.toLowerCase()}`,
      `Insira o nome do novo fluxo de ${flowTypeDescription.toLowerCase()}`,
      'OK', 'Cancelar',
      `NovoFluxo${flowTypeDescription}X`,
      '^[a-zA-Z][a-zA-Z0-9_]+',
      'Um nome válido deve ter entre 1 e 100 caracteres, deve ser iniciado por letra e deve ser composto somente por letras, números e underscore.',
      100, 1, true
    );
    result$.asObservable()
      .pipe()
      .subscribe(
        input => {
          if (input !== null) {
            const flowName = input.replace(/\s/g, '');
            this.bpService.createStateLibraryFlow(flowName, Number(this.bpId), flowType)
              .subscribe( newFlowId => {
                  this.unrelatedLibraryItems.push(newFlowId);
                  this.tabIdToSelect = 2;
                  this.libraryTabIdToSelect = 0;
                  this.filterFlowText = '';
                  this.loadFlowLibrary();
                },
                error1 => {
                  this.filterFlowText = '';
                  this.errorMessageFlow = error1;
                });
          }
        }
      );
  }

  onAddLayout() {
    this.errorMessageLayout = '';
    const result$ = this.modalService.showInputModal(
      this.destComponent,
      `Novo layout de tela`,
      `Insira o nome do novo layout de tela`,
      'OK', 'Cancelar',
      `NovoLayoutTelaX`,
      '^[a-zA-Z][a-zA-Z0-9_]+',
      'Um nome válido deve ter entre 1 e 100 caracteres, deve ser iniciado por letra e deve ser composto somente por letras, números e underscore.',
      100, 1, true
    );
    result$.asObservable()
      .pipe()
      .subscribe(
        input => {
          if (input !== null) {
            const layoutName = input.replace(/\s/g, '');
            console.log(layoutName);
            this.bpService.createStateLibraryLayout(layoutName, Number(this.bpId))
              .subscribe( newLayoutId => {
                  this.unrelatedLibraryItems.push(newLayoutId);
                  this.libraryTabIdToSelect = 1;
                  this.tabIdToSelect = 2;
                  this.filterLayoutText = '';
                  this.loadLayoutLibrary();
                },
                error1 => {
                  this.filterLayoutText = '';
                  this.errorMessageLayout = error1;
                });
          }
        }
      );
  }

  onAddView() {
    this.errorMessageView = '';
    const result$ = this.modalService.showInputModal(
      this.destComponent,
      `Nova visão`,
      `Insira o nome da nova visão`,
      'OK', 'Cancelar',
      `NovaVisaoX`,
      '^[a-zA-Z][a-zA-Z0-9_]+',
      'Um nome válido deve ter entre 1 e 100 caracteres, deve ser iniciado por letra e deve ser composto somente por letras, números e underscore.',
      100, 1, true
    );
    result$.asObservable()
      .pipe()
      .subscribe(
        result => {
          if (result !== null) {
            this.bpService.createStateLibraryView(result, Number(this.bpId))
              .subscribe( newLayoutId => {
                  this.libraryTabIdToSelect = 2;
                  this.tabIdToSelect = 2;
                  this.filterViewsText = '';
                  this.loadViewLibrary();
                },
                error1 => {
                  this.filterViewsText = '';
                  this.errorMessageView = error1;
                });
          }
        }
      );
  }

  onOpenLibrary(itemType: number, designElementType: number) {
    this.errorMessage = '';
    this.bpService.getUnrelatedLibraryItems(this.bpId, itemType, designElementType)
      .subscribe(
        result => {
          this.unrelatedLibraryItems = result;
        }, error1 => {
          this.errorMessage = error1;
        }
      );
  }

  onDetailsClick(libraryItem: any) {
    const libraryItemId = libraryItem.libraryItemId;
    const libraryIitemName = libraryItem.name;
    const designElementType = this.getDesignElementType(libraryItem.itemType);
    this.modalService.showModal(this.libraryDetailsComponent, `Detalhes do elemento ${libraryIitemName}`,
      libraryItemId, `${this.bpId.toString()}|${designElementType}`);
  }

  loadBusinessProcessValidationErrors() {
    this.errorMessageValidation = '';
    this.bpService.loadBusinessProcessValidationErrors(this.bpId)
      .subscribe( errorList => {
        this.businessProcessErrorList = errorList;
      }, error1 => {
        this.errorMessageValidation = error1;
        }
      );
  }

  getDesignElementType(itemType: number): number {
    switch (itemType) {
      case 1:
        return 4;
      case 2:
        return 5;
      case 3:
        return 6;
      default:
        return 0;
    }
  }

  getItemTypeName(itemType: number): string {
    switch (itemType) {
      case 1:
        return 'fluxo';
      case 2:
        return 'layout';
      case 3:
        return 'visão';
      default:
        return 'desconhecido';
    }
  }

  getFieldTypeEnumTranslated(fieldType) {
    return EnumTranslator.getEnumValueTranslated(FieldType[fieldType]);
  }

}
